import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useRef, useState } from 'react';
import { Button, InputAdornment, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { DatePicker, Icon, SimpleModal } from '@livable/saas-react-components';
import useStyles from './styles';
const CELL_BORDER = '1px solid #e0e0e0';

// Defined at module level — never remounts due to parent re-renders
const AddNewRateFormContent = _ref => {
  let dataRef = _ref.dataRef;
  const classes = useStyles();
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    rateName = _useState2[0],
    setRateName = _useState2[1];
  const _useState3 = useState('charge'),
    _useState4 = _slicedToArray(_useState3, 2),
    rateType = _useState4[0],
    setRateType = _useState4[1];
  const _useState5 = useState('$'),
    _useState6 = _slicedToArray(_useState5, 2),
    rateIn = _useState6[0],
    setRateIn = _useState6[1];
  const _useState7 = useState('0.00'),
    _useState8 = _slicedToArray(_useState7, 2),
    rateValue = _useState8[0],
    setRateValue = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    ratePerUnit = _useState0[0],
    setRatePerUnit = _useState0[1];
  const _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    schedules = _useState10[0],
    setSchedules = _useState10[1];
  const handleAddSchedule = () => setSchedules(prev => [...prev, {
    id: Date.now(),
    date: '',
    rate: '0.00'
  }]);
  const handleRemoveSchedule = id => setSchedules(prev => prev.filter(s => s.id !== id));

  // Sync form data to parent ref (no re-render triggered)
  if (dataRef) {
    dataRef.current = {
      rateName,
      rateType,
      rateIn,
      rateValue,
      ratePerUnit,
      schedules
    };
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    placeholder: "Rate name",
    value: rateName,
    onChange: e => setRateName(e.target.value),
    variant: "outlined"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 600,
      marginBottom: 12
    }
  }, "Type"), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    exclusive: true,
    size: "small",
    value: rateType,
    onChange: (_, val) => val && setRateType(val)
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "charge"
  }, "Charge"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "credit"
  }, "Credit"))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 600,
      marginBottom: 12
    }
  }, "Rate setup"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 60,
      flexShrink: 0,
      padding: '12px 12px 12px 0'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "Rate in")), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      padding: '8px 0 8px 12px'
    }
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    exclusive: true,
    size: "small",
    value: rateIn,
    onChange: (_, val) => val && setRateIn(val)
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "$"
  }, "$"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "%"
  }, "%")))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 60,
      flexShrink: 0,
      padding: '12px 12px 12px 0'
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "Rate")), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      padding: '4px 0 4px 12px',
      display: 'flex',
      alignItems: 'center',
      gap: 8
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    style: {
      width: 110
    },
    value: rateValue,
    onChange: e => setRateValue(e.target.value),
    InputProps: {
      startAdornment: rateIn === '$' ? /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, "$") : null,
      endAdornment: rateIn === '%' ? /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, "%") : null
    }
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "per"), /*#__PURE__*/React.createElement(Select, {
    size: "small",
    value: ratePerUnit,
    onChange: e => setRatePerUnit(e.target.value),
    displayEmpty: true,
    style: {
      flex: 1
    },
    renderValue: val => val || 'Select value'
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: ""
  }, "Select value"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "unit"
  }, "Unit"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "gal"
  }, "gal"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "hcf"
  }, "HCF"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "kgal"
  }, "Kgal"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "kWh"
  }, "kWh"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "BTU"
  }, "BTU"))))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: 24
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    style: {
      fontWeight: 600,
      marginBottom: 12
    }
  }, "Schedule rate change"), schedules.map(schedule => /*#__PURE__*/React.createElement("div", {
    key: schedule.id,
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginBottom: 8,
      padding: '8px 12px',
      border: CELL_BORDER,
      borderRadius: 4
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "After"), /*#__PURE__*/React.createElement("div", {
    className: classes.scheduleDatePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    format: "MM/dd/yy",
    value: schedule.date || null,
    onChange: date => setSchedules(prev => prev.map(s => s.id === schedule.id ? _objectSpread(_objectSpread({}, s), {}, {
      date
    }) : s))
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      fontWeight: 600
    }
  }, "change rate to"), /*#__PURE__*/React.createElement(TextField, {
    size: "small",
    value: schedule.rate,
    onChange: e => setSchedules(prev => prev.map(s => s.id === schedule.id ? _objectSpread(_objectSpread({}, s), {}, {
      rate: e.target.value
    }) : s)),
    style: {
      width: 100
    },
    InputProps: {
      startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start"
      }, "$")
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "actionButtonInvert",
    style: {
      minWidth: 0,
      padding: 5
    },
    onClick: () => handleRemoveSchedule(schedule.id)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  })))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    size: "small",
    onClick: handleAddSchedule
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Add schedule"))));
};
export const AddNewRateModal = _ref2 => {
  let onSave = _ref2.onSave;
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isOpen = _useState12[0],
    setIsOpen = _useState12[1];
  const _useState13 = useState(0),
    _useState14 = _slicedToArray(_useState13, 2),
    formKey = _useState14[0],
    setFormKey = _useState14[1];
  const dataRef = useRef({});
  const handleOpen = () => {
    setFormKey(k => k + 1);
    setIsOpen(true);
  };
  const handleClose = () => setIsOpen(false);
  const handleSave = () => {
    onSave === null || onSave === void 0 || onSave(dataRef.current);
    handleClose();
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButtonInvert",
      size: "small",
      onClick: handleOpen
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "actionText"
    }, "Add rate")),
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, "Add new rate"),
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      onClick: handleSave
    }, "Save rate"),
    isOpen: isOpen,
    handleOpen: handleOpen,
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(AddNewRateFormContent, {
    key: formKey,
    dataRef: dataRef
  }));
};